export default class LocaleService {
  /* @ngInject */
  constructor(amMoment, tmhDynamicLocale) {
    this.amMoment = amMoment;
    this.tmhDynamicLocale = tmhDynamicLocale;
  }

  setLanguage(language) {
    this.amMoment.changeLocale(language);
    this.tmhDynamicLocale.set(language);
  }

  setTimezone(timezone) {
    this.amMoment.changeTimezone(timezone);
  }
}
